<template>
  <div class="flex flex-col items-center">
    <div class="p-2 sm:p-4 bg-surface-50 dark:bg-surface-400/5 rounded-lg w-full">
      <HelpTopicsIllustration />
    </div>

    <div class="mt-6">
      <p class="font-semibold text-lg text-primary mb-4">
        {{ $t("findHelpTipTitle") }}
        <span>
          <SparklesIcon class="h-5 w-5 text-yellow-500 inline-block" />
        </span>
      </p>
      <p>
        {{ $t("findHelpTipText") }}
      </p>
    </div>
  </div>
</template>

<script setup lang="ts">
import HelpTopicsIllustration from "./HelpTopicsIllustration.vue";
</script>
